export default __webpack_public_path__ + "static/media/AstroneLogo.ad32dac6.svg";